# This file doesn't do anything for Desktop.
# It only handles the show more / show less buttons for small (mobile) viewports.

class FactualInfo

  constructor: (@el) ->
    @$el = $ @el
    @$showMore = @$el.find '.show-more a'
    @$showLess = @$el.find '.show-less a'

    @bindEventHandlers()

  bindEventHandlers: ->
    @$showMore.click @showMore
    @$showLess.click @showLess

  showMore: (evt) =>
    evt.preventDefault()
    @$el.addClass 'show-more-expanded'

  showLess: (evt) =>
    evt.preventDefault()
    @$el.removeClass 'show-more-expanded'

$ ->
  $el = $ '.mpp-container .factual-info'
  return unless $el.length
  new FactualInfo($el)
